<div class="map-container">
  <button class="search-area" *ngIf="loadingLocations || isMovedCoordinate" (click)="loadingLocations ? '' : searchHere()">
    <ng-container *ngIf="loadingLocations; else elseTemplate">
      <div class="snippet" data-title="dot-flashing">
        <div class="stage">
          <div class="dot-flashing"></div>
        </div>
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      Search in this area
    </ng-template>
  </button>
  <div class="map" id="map" class="match-parent"></div>
  <p class="loading-practitioners" *ngIf="loading"><i class="fa fa-spin fa-spinner"></i>Fetching practitioners</p>
  <div class="provider-view pracs-{{provider?.pracs?.length}}" *ngIf="provider?.business?.id">
    <div class="body-list" #parentElement>
      <ng-container *ngIf="checkIfItHasScroll(parentElement,pracList) && provider?.pracs.length > 1">
        <button class="arrow-btn prev" (click)="goToPrev(pracList)">
          <img src="../../../../../assets/images/booking/left-arrow.svg" alt="">
        </button>
        <button class="arrow-btn next" (click)="goToNext(pracList)">
          <img src="../../../../../assets/images/booking/right-arrow.svg" alt="">
        </button>
      </ng-container>

      <div class="pracs-list" #pracList>
        <ng-container *ngFor="let prac of provider?.pracs">
          <div class="prac-item" [ngClass]="{'one': provider?.pracs?.length === 1}">
            <div class="top">
              <div class="left">
                <img src="{{prac.logo_image}}" alt="">
              </div>
              <div class="right">
                <div class="prac-detail">
                  <p class="name">
                    {{ getDisplayName(prac) }}
                  </p>
                  <p class="title">{{prac.profession_title}}</p>
                  <p class="biz">{{provider.name}}</p>
                </div>
              </div>
            </div>
            <div class="bottom">
              <button class="secondary" (click)="fetchAvailability(prac)">
                <ng-container *ngIf="apploading && pracUuId === prac.uuid; else appLoadingTemp">
                  <i class="fa fa-spin fa-spinner"></i>
                </ng-container>
                <ng-template #appLoadingTemp>
                  Book appointment
                </ng-template>
              </button>
              <!-- <button class="secondary" (click)="goToProfile(prac)">View profile</button> -->
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
